import { cachedRequestByIdReducer } from './helpers';
import { values } from 'lodash';

import { cloudAutomationBuildInfoActionTypes } from './../actions/types';

const cloudAcquisitionBuildInfo =
  cachedRequestByIdReducer(cloudAutomationBuildInfoActionTypes);
export default cloudAcquisitionBuildInfo;

export const getCloudBuildInfo = (state) => {
  return values(state.cloudAcquisitionBuildInfo.byId);
};

export const getCloudBuildNumber = (state) => {
  const buildInfo = getCloudBuildInfo(state);
  if (buildInfo.length > 0) {
    return buildInfo[0].buildNumber;
  }
  else {
    return -1;
  }
};

export const getCloudBuildTimestamp = (state) => {
  const buildInfo = getCloudBuildInfo(state);
  if (buildInfo.length > 0) {
    return buildInfo[0].timestamp;
  }
  else {
    return null;
  }
};


// WEBPACK FOOTER //
// src/reducers/cloudAcquisitionBuildInfo.js